var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "random-number" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Lower Range")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Lower Range",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.options.lowerRange,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "lowerRange", $$v)
            },
            expression: "clone.options.lowerRange",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Upper Range")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "End Number",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.options.upperRange,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "upperRange", $$v)
            },
            expression: "clone.options.upperRange",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Decimal Point"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "End Number",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.options.decimalPoint,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "decimalPoint", $$v)
            },
            expression: "clone.options.decimalPoint",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }